import React from 'react'
import CuentaSelected from "../../helpers/CuentaSelected";
import AppBreadcrumbs from "../../components/AppBreadcrumbs";
import Api from "../../helpers/Api";
import Env from "../../config/env";
import AppToast from "../../ui/AppToast";
import 'react-confirm-alert/src/react-confirm-alert.css';
import {withRouter} from 'react-router';
import Grid from "@material-ui/core/Grid";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import {Button} from '@material-ui/core';
import Card from "@material-ui/core/Card";
import Icon from "@material-ui/core/Icon";
import ValidateForm from "../../helpers/ValidateForm";
import {Link} from "react-router-dom";
import AppTextArea from "../../ui/AppTextArea";
import Redirect from "../../helpers/Redirect";

const initialForm = {
    motivo: {
        key: 'motivo',
        value: '',
        required: true,
        disabled: false,
    },
    descripcion: {
        key: 'descripcion',
        value: '',
        required: false,
        disabled: false,
    },
};

class DigitalInvoiceFormDelete extends React.Component {

    PqrForm = React.createRef();

    constructor(props) {
        super(props);

        this.state = {
            form: initialForm,
            account: {},
            dataMotivo: [],
            dataFactura: [],
            open: false,
            url: ''
        };
    }

    async componentDidMount() {
        this.setState({
            account: CuentaSelected.get()
        });

        this.loadForm();
    }

    getMotivos = async () => {
        const data = await Api.get(`${Env.UrlBackend}/invoice-digital/motivos`);
        if (!data.success) {
            AppToast(data.message, false);
        }
        this.setState({
            dataMotivo: data.data
        });
    }
    
    getInvoiceDigital = async () => {
        const account = CuentaSelected.get();
        const params = {
            cuenta: account.cuentaCodigo,
            tipo: 'NML',
        }

        const data = await Api.post(`${Env.UrlBackend}/invoice-digital/validate`, params);
        if (!data.success) {
            AppToast(data.message, false);
        }
        this.setState({dataFactura: data.data});
    }

    loadForm = async () => {
        await this.getMotivos();
        await this.getInvoiceDigital();

        this.setState({
            form: {
                ...this.state.form,
                email: {
                    ...this.state.form.email,
                    value: (this.state.dataFactura.email1) ? this.state.dataFactura.email1 : '',
                    disabled: true,
                },
                email2: {
                    ...this.state.form.email2,
                    value: (this.state.dataFactura.email2) ? this.state.dataFactura.email2 : '',
                    disabled: false,
                },
                email3: {
                    ...this.state.form.email3,
                    value: (this.state.dataFactura.email3) ? this.state.dataFactura.email3 : '',
                    disabled: false,
                },
                calidad: {
                    ...this.state.form.calidad,
                    value: this.state.dataFactura.calidad_de_id,
                    disabled: false,
                },
            },
        });
    }

    handleChange = async (e) => {
        const {value, name} = e.target;

        this.setState((statePrev) => {
            return {
                form: {
                    ...statePrev.form,
                    [name]: {
                        ...statePrev.form[name],
                        value: value
                    }
                }
            }
        });
    }

    handleSubmit = async (e) => {
        e.preventDefault();
        const account = CuentaSelected.get();

        // Valida los campos obligatorios
        if (!ValidateForm(this.state.form)) {
            return false;
        }
        
        const paramsEmail = {
            cuenta: account.cuentaCodigo,
            tipo: 'NML',
        }
        const dataEmail = await Api.post(`${Env.UrlBackend}/invoice-digital/inactive`, paramsEmail);
        if (!dataEmail.success) {
            AppToast('Error inactivando factura digital', false);
            return false;
        }

        const paramsPrivacy = {
            user: account.cuentaCodigo,
            type: 'FD',
            agree: 'N',
            source: Env.ApplicationCode,
        }

        const dataPrivacy = await Api.post(`${Env.UrlBackend}/privacy-policy/update`, paramsPrivacy);
        if (!dataPrivacy.success) {
            AppToast('Error desvinculando factura digital (política de privacidad)', false);
            return false;
        }

        const paramsInsert = {
            cuenta: account.cuentaCodigo,
            desvinculacion_motivo: this.state.form.motivo.value,
            descripcion: this.state.form.descripcion.value,
        }

        const dataInsert = await Api.post(`${Env.UrlBackend}/invoice-massive/get-insert-motivos`, paramsInsert);
        if (!dataInsert.success) {
            AppToast('Error registrando motivo de desvinculación de la factura digital', false);
            return false;
        }

        AppToast('La cuenta se desvinculó con éxito', true);

        this.setState({
            url: '/accounts'
        });
    }

    render() {

        return (
            <div className='container-form'>

                <Redirect url={this.state.url}/>

                <AppBreadcrumbs
                    links={[
                        {
                            url: 'accounts',
                            label: 'Cuentas'
                        }
                    ]}
                    actual='Factura Digital'
                />

                <div style={{textAlign: 'center', paddingLeft: '30px', paddingRight: '30px'}}>

                    <h2>Retiro de la Factura Digital</h2>

                    <form onSubmit={this.handleSubmit}>
                        <Card style={{padding: '20px', width: '80%', margin: 'auto'}}>
                            <div style={{height: '100px'}}>
                                <table className='custom-table'>
                                    <tbody>
                                    <tr>
                                        <th>Nro Cuenta</th>
                                        <td>{this.state.account.cuentaCodigo}</td>
                                        <th>Cliente</th>
                                        <td>{this.state.account.cuentaCliente}</td>
                                    </tr>
                                    <tr>
                                        <th>Dirección</th>
                                        <td>{this.state.account.DIRECCION}</td>
                                        <th>Factura</th>
                                        <td>{this.state.account.cuentaFactura}</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div style={{height: '300px'}}>
                                <Grid container spacing={1}>
                                    <Grid item xs={12} sm={12}>
                                        <FormControl required variant="outlined" style={{width: '100%'}}>
                                            <InputLabel id="demo-simple-select-outlined-label">Motivo</InputLabel>
                                            <Select
                                                labelId="demo-simple-select-outlined-label"
                                                id={this.state.form.motivo.key}
                                                name={this.state.form.motivo.key}
                                                value={this.state.form.motivo.value}
                                                label="Motivo"
                                                onChange={this.handleChange}
                                                required={this.state.form.motivo.required}
                                                variant='outlined'
                                            >

                                                {this.state.dataMotivo.map((val, index) => {
                                                    return (
                                                        <MenuItem key={index}
                                                                value={val.id}>{val.descripcion}</MenuItem>
                                                    );
                                                })}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={12}>
                                        <AppTextArea
                                            id={this.state.form.descripcion.key}
                                            name={this.state.form.descripcion.key}
                                            value={this.state.form.descripcion.value}
                                            label="Observación"
                                            onChange={this.handleChange}
                                            required={this.state.form.descripcion.required}
                                            helperText={`${this.state.form.descripcion.value.length}/100`}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Link to='accounts' variant="body2">
                                            <Button
                                                type='button'
                                                variant="contained"
                                                color="secondary"
                                                size="small"
                                                startIcon={<Icon>close</Icon>}
                                                style={{margin: '10px'}}>
                                                Cancelar
                                            </Button>
                                        </Link>
                                        
                                        <Button
                                            type='submit'
                                            variant="contained"
                                            color="secondary"
                                            size="small"
                                            startIcon={<Icon>check</Icon>}
                                            style={{margin: '10px'}}>
                                            Desvincular
                                        </Button>
                                        
                                    </Grid>
                                </Grid>
                            </div>
                        </Card>
                    </form>
                </div>
            </div>

        );
    }
}

export default withRouter(DigitalInvoiceFormDelete)
